const SortingOrders = {
    ascending: 'asc',
    descending: 'desc',
};

export default SortingOrders;
